import httpClient from './http-client';
import mockServiceDirectoryService from './serviceDirectory.service.mock';

let serviceDirectoryService;

if (process.env.NODE_ENV === 'development') {
  serviceDirectoryService = mockServiceDirectoryService;
} else {
  serviceDirectoryService = {
    // params: locale, query, group, provider, isChargeable, page, pageSize
    getList(params) {
      return httpClient.get('/serviceDirectory', { params });
    },

    getById(id) {
      return httpClient.get(`/serviceDirectory/${id}`);
    },
  };
}

export default serviceDirectoryService;
